import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { State } from '../../../../vista-usuario/vista-usuario.state';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';

import { FormActionType, Pais } from '@rpe/registro-personas-empresas-lib';

import { PersonaFormComponent } from '../persona-form/persona-form.component';

import { filter } from 'rxjs/operators';
import { selectUsuario } from '../../../entity-usuarios/entity-usuarios.selectors';
import { entityPersonasAddRequest } from '../../entity-personas.actions';
import { Persona, PersonaFormInput } from '../../entity-personas.model';

@Component({
  selector: 'rpe-entity-persona-form-container',
  templateUrl: './entity-persona-form-container.component.html',
  styleUrls: ['./entity-persona-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityPersonaFormContainerComponent implements OnInit, OnDestroy {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  @ViewChild(PersonaFormComponent) personaForm: PersonaFormComponent;

  paises$: Observable<Pais[]> | undefined;

  formValid = false;
  formValue: Persona;

  suscriptions: Subscription[] = [];

  // mover el form input para donde corresponda
  formInput: PersonaFormInput = {
    action: FormActionType.Add,
    tipos_documento: null,
    paises: null,
    localidades: null,
    departamentos: null,
    direcciones_geografica_IDE: null,
    direccion_geografica: null,
    documento_persona: null,
    paises_documento: null,
    user: null
  };

  constructor(public store: Store<State>, private ref: ChangeDetectorRef) {}

  ngOnInit(): void {
    const s3 = this.store
      .pipe(select(selectUsuario))
      .pipe(filter((u) => !!u))
      .subscribe((user) => {
        this.formInput = {
          ...this.formInput,
          user: user,
          documento_persona: {
            id: null,
            pais_codigo: user.pais_documento,
            tipo_documento_codigo: user.tipo_documento,
            numero: user.numero_documento
          }
        };
      });

    this.suscriptions.push(s3);
  }

  ngOnDestroy(): void {
    this.suscriptions.forEach((s) => s.unsubscribe());
  }

  formStatusChanges(status: string) {
    this.formValid = status === 'VALID';
  }

  formValueChanges(persona: Persona) {
    this.formValue = persona;
  }

  onSubmit() {
    if (this.formValid) {
      if (this.formInput.action === FormActionType.Add) {
        this.store.dispatch(
          entityPersonasAddRequest({
            item: this.formValue
          })
        );
      }
    } else {
      this.personaForm.onShowErrors();
    }
  }

  /*onCancel() {
    this.router.navigate(['/']);
  }*/
}
